import React, { useMemo, useRef } from 'react';
import { FrontIframeOverlay } from '../../../ips-react-front-fw/components/overlay';

type Props = {
  open: boolean;
  loading: boolean;
  addUrl: string;
  openPageUrl: string;
  listUrl: string;
  onClose: () => void;
  onIframeLoad: (iframe: HTMLIFrameElement | null) => void;
};

export const PaymentOverlay: React.FC<Props> = ({
  open,
  loading,
  addUrl,
  openPageUrl,
  listUrl,
  onClose,
  onIframeLoad,
}) => {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);

  const labels = useMemo(
    () => ({
      title: 'Zahlungsmethode hinzufügen',
      openPage: 'Vollseite öffnen',
      backToList: 'Zur Zahlungsarten-Übersicht',
      close: 'Close',
      iframeTitle: 'Add payment method',
    }),
    []
  );

  return (
    <FrontIframeOverlay
      open={open}
      onClose={onClose}
      src={addUrl}
      title={labels.title}
      loading={loading}
      iframeRef={iframeRef}
      onLoad={() => onIframeLoad(iframeRef.current)}
      panelClassName="ips-front-payment-overlay-panel"
      wrapperClassName="ips-front-payment-overlay"
      iframeTitle={labels.iframeTitle}
      closeLabel={labels.close}
      openPageHref={openPageUrl}
      openPageLabel={labels.openPage}
      footerHref={listUrl}
      footerLabel={labels.backToList}
    />
  );
};
